import { createAction } from "redux-actions";

const storeNitReports = createAction("STORE_NIT_REPORTS");

export const indexNitReports = createAction("API_INDEX_NIT_REPORTS", (page, per_page) => ({
  baseURL: process.env.REACT_APP_SATTV_ENDPOINT,
  url: "/nit-reports?page=" + page + "&per_page=" + per_page,
  onSuccessAction: storeNitReports
}));
